import { AccordionButton, Flex, Stack, Text } from '@chakra-ui/react';
import { DiscountCode } from '@time-line/components/common';
import { Price } from 'components/cart/Price';
import { ProductPriceSaving } from 'components/product/ProductPriceSaving';
import type { Money } from 'types/product/Money';
import type { Variant } from 'types/product/Variant';

import { ProductConfiguratorRadioButton } from './ProductConfiguratorRadioButton';

interface SingleVariantAccordionItemProps {
  title: string;
  isOptionsClickable: boolean;
  isExpanded: boolean;
  availableForSale: boolean;
  showSavingsAsAmount?: boolean;
  isDiscountHidden?: boolean;
  variant: Variant;
  discountCodes?: string[];
  otpPrice?: Money;
}

export function SingleVariantAccordionItem({
  title,
  isOptionsClickable,
  isExpanded,
  availableForSale,
  showSavingsAsAmount,
  isDiscountHidden,
  discountCodes,
  variant,
  otpPrice,
}: SingleVariantAccordionItemProps) {
  const { compareAtPrice: rawCompareAtPrice, price } = variant;
  const compareAtPrice = isDiscountHidden
    ? undefined
    : (otpPrice ?? rawCompareAtPrice);

  return (
    <AccordionButton
      _hover={{}}
      py={0}
      px={0}
      alignItems="start"
      as={isOptionsClickable ? 'button' : 'div'}
    >
      <Flex
        as="span"
        sx={{
          '--dot-size': isExpanded ? 'scale(1)' : 'scale(0)',
        }}
        _hover={{
          '--dot-size': isExpanded ? 'scale(1):' : 'scale(0.5)',
        }}
        width="100%"
        alignItems="center"
        py="2xs"
        px="xs"
        height="100%"
        minH={66}
        gap="2xs"
      >
        {isOptionsClickable && (
          <ProductConfiguratorRadioButton isActive={isExpanded} />
        )}
        <Stack spacing="2px" w="full" minW="0" alignSelf="center">
          <Flex
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Text size="title2" textAlign="left" as="h2">
              {title}
            </Text>
            <Price
              subtotalAmount={compareAtPrice}
              totalAmount={price}
              direction="row-reverse"
            />
          </Flex>

          {price && !isDiscountHidden && availableForSale && (
            <Flex
              flexDirection="row"
              alignItems="center"
              justifyContent="space-between"
              gap="4xs"
            >
              <ProductPriceSaving
                compareAtPrice={compareAtPrice}
                price={price}
                lineHeight={1}
                showAsAmount={showSavingsAsAmount}
              />
              {discountCodes && discountCodes.length === 1 && (
                <Flex gap="4xs" flexDirection="row" ml="auto">
                  <DiscountCode size="sm">{discountCodes[0]}</DiscountCode>
                </Flex>
              )}
            </Flex>
          )}
        </Stack>
      </Flex>
    </AccordionButton>
  );
}
